import * as React from 'react';

const plusIcon = ( <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.182861" width="32.6345" height="32.6345" rx="16.3172" fill="#024EC1"/>
<path fillRule="evenodd" clipRule="evenodd" d="M16.1586 10.9026C16.5341 10.9026 16.8384 11.207 16.8384 11.5825V15.6618H20.9178C21.2932 15.6618 21.5976 15.9662 21.5976 16.3417C21.5976 16.7172 21.2932 17.0216 20.9178 17.0216H16.8384V21.1009C16.8384 21.4764 16.5341 21.7807 16.1586 21.7807C15.7831 21.7807 15.4787 21.4764 15.4787 21.1009V17.0216H11.3994C11.0239 17.0216 10.7195 16.7172 10.7195 16.3417C10.7195 15.9662 11.0239 15.6618 11.3994 15.6618H15.4787V11.5825C15.4787 11.207 15.7831 10.9026 16.1586 10.9026Z" fill="white"/>
</svg>);

export default plusIcon;
